import { z } from 'zod';
import { syncBookkeepingSchema, uuidSchema } from './base.js';

export const taskTagSchema = syncBookkeepingSchema.extend({
  task_id: uuidSchema,
  tag_id: uuidSchema,
});

export type TaskTag = z.infer<typeof taskTagSchema>;

export const taskTagCreateSchema = taskTagSchema.pick({ task_id: true, tag_id: true });

export type TaskTagCreate = z.infer<typeof taskTagCreateSchema>;
